/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
import React from 'react';

interface IconActionButtonProps {
  icon: string;
  onClick?: () => void;
  ariaLabel: string;
  disabled?: boolean;
  className?: string;
  variant?: 'light' | 'secondary';
  balloonPosition?: 'left' | 'right' | 'up' | 'down';
}

const IconActionButton: React.FC<IconActionButtonProps> = ({
  icon,
  onClick,
  ariaLabel,
  disabled = false,
  className = '',
  variant = 'light',
  balloonPosition = 'left',
}) => {
  return (
    <button
      className={`btn databalloon btn-${variant} btn-sm mx-1 d-flex justify-content-center align-items-center ${className}`}
      aria-label={ariaLabel}
      data-balloon-blunt
      data-balloon-pos={balloonPosition}
      disabled={disabled}
      onClick={onClick}
    >
      <i className="material-icons p-0 m-0">{icon}</i>
    </button>
  );
};

export default IconActionButton;
